import router from '@/routers';

export const isEmpty = value => ['', ' ', undefined, 'undefined', null, 'null'].includes(value);

export const routerPush = async where => {
  try {
    const TYPE = typeof where;
    const pusher = dest => router.push(dest).catch(() => true);

    const matcher = {
      string: path => pusher({ path }),
      object: obj => pusher(obj)
    };

    return matcher[TYPE](where);
  } catch (err) {
    console.error(`routerPush err : `, err);
    throw err;
  }
};

export const routerReplace = async where => {
  try {
    const TYPE = typeof where;
    const replacer = dest => router.replace(dest).catch(err => true);

    const matcher = {
      string: path => replacer({ path }),
      object: obj => replacer(obj)
    };

    return matcher[TYPE](where);
  } catch (err) {
    console.error(`routerReplace err : `, err);
    throw err;
  }
};

export const setTit = value => {
  if (isEmpty(value)) {
    if (router.currentRoute.name === 'main') {
      document.title = 'Main | PULIP';
    }
  } else {
    document.title = value;
  }
};
